import type { Editor } from 'slate';

import { isAlineEditor } from '../../slate-api';
import type { UUID } from '../../types/type-helpers';

export const authorizationQueries = {
  isUserAuthorizedToCompleteNonSigField(
    editor: Editor,
    options: {
      assigneeId: UUID | null;
    }
  ): { isUserAuthorized: boolean } {
    const { assigneeId } = options;
    if (!isAlineEditor(editor)) return { isUserAuthorized: false };

    const isUnassigned = !assigneeId;
    const isUserAssignee = editor.userState?.editingUserId === assigneeId;

    return { isUserAuthorized: isUnassigned || isUserAssignee };
  },

  isUserAuthorizedToCompleteSigField(
    editor: Editor,
    options: { assigneeId: UUID }
  ): { isUserAuthorized: boolean } {
    const { assigneeId } = options;
    if (!isAlineEditor(editor)) return { isUserAuthorized: false };

    const isUserAssignee = editor.userState?.editingUserId === assigneeId;

    return { isUserAuthorized: isUserAssignee };
  },
};
